import anonymousSupportSaga from './anonymousSupportSaga'
import loggedinUserSupportSaga from './loggedinUserSupportSaga'

const supportSaga = [anonymousSupportSaga(), loggedinUserSupportSaga()]

export default supportSaga
